import React from 'react';

/**
 * Reference Tables / Charts segmented control (top-right of page).
 */
export default function SegmentedViewToggle({ options, value, onChange, className = '' }) {
  return (
    <div className={`app-segmented ${className}`.trim()} role="group">
      {options.map((opt) => (
        <button
          key={opt.id}
          type="button"
          className={`app-segmented__btn${value === opt.id ? ' app-segmented__btn--active' : ''}`}
          onClick={() => onChange(opt.id)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
